import $ from 'jquery'

$('.feed-seedling-type__wrapper').on('click', function () {
  $(this)
    .parent()
    .find('.feed-seedling-type__actions')
    .toggleClass('feed-seedling-type__actions--active')
})

$('.feed-seedling-type__actions-closer').on('click', function () {
  $(this)
    .closest('.feed-seedling-type')
    .find('.feed-seedling-type__actions')
    .toggleClass('feed-seedling-type__actions--active')
})
